// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d8dd44ee","972":"8ebfdf16"}[chunkId] + ".chunk.js";
};